export const chunk = (arr, size)  => {
    return arr.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index/size);

        if(!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
    }, [])
}

export const isValidationErrorStatus = (response) => {
    return response.status && response.status === 422
}

export const formatValidationErrors = (errors) => {
    let validationErrors = {};

    for (let error in errors) {
        if (errors.hasOwnProperty(error)) {
            validationErrors[error] = isDefined(errors[error][0]) ? errors[error][0] : 'This field is invalid';
        }
    }

    return validationErrors;
};

export const isUndefined = (val) => { return typeof val === 'undefined'; }
export const isDefined = (val) => { return typeof val !== 'undefined'; }



